import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Banner, Heading, Paragraph } from '@zillow/constellation';
import { StyledContainer } from '@zillow/zrs-comet';

import { FETCH_DATA_ERROR_MSG } from '../../../../constants/messages';
import useBrownoutWarningMessage from '../../../../utils/apis/useBrownoutWarningMessage';
import { isBrownoutOn } from '../../../../utils/brownoutUtil';

function ErrorBanner({ error }) {
  const [brownoutMessage, setBrownoutMessage] = useState(null);
  const {
    data: brownoutWarningMessage,
    isError,
    error: errorResponse,
  } = useBrownoutWarningMessage({
    select(response) {
      return response.data?.response?.data?.brownoutWarningMessage;
    },
  });

  useEffect(() => {
    if (isBrownoutOn(errorResponse)) {
      setBrownoutMessage(errorResponse.data.error.message);
    }
  }, [isError, errorResponse]);

  const finalBrownoutMessage = (brownoutMessage ?? brownoutWarningMessage)?.trim();
  // Brownout message takes precedence over general error.
  if (finalBrownoutMessage) {
    return (
      <section className="BrownoutWarningMessage">
        <StyledContainer backgroundColor="lightGrey" padding="lg">
          <Heading level="6">Alert:</Heading>
          <Paragraph>{finalBrownoutMessage}</Paragraph>
        </StyledContainer>
      </section>
    );
  }

  if (error) {
    return (
      <Banner
        {...{
          appearance: 'error',
          body: FETCH_DATA_ERROR_MSG,
        }}
      />
    );
  }

  return null;
}

ErrorBanner.propTypes = {
  error: PropTypes.any,
};

export default ErrorBanner;
